@if(error) {
  <div class="alert alert-danger" role="alert">{{error}}</div>
}
@if(banner) {
  <div class="alert alert-info" role="alert">{{banner}}</div>
}
<div class="span9">
  <h1 data-automation-name="registeredReportIndex"> Registered Reports</h1>
</div>
<p class="lead">
  Registered Reports are reports scheduled by the VTN to be sent by the VEN. Each registered report is created from
  a metadata report and the metadata report's RIDs, and includes the rate that the VTN has requested for reporting.
  The VEN may not create registered reports, and the UI will not allow registered report creation.
</p>

@if(isLoading) {
  <app-loader
    message="Loading Registered Reports...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>Report ID</th>
      <th>Report Request ID</th>
      <th>Ven ID</th>
      <th>Metadata Report ID [id : label]</th>
      <th>Granularity</th>
      <th>Report back duration</th>
      <th>Report interval start</th>
      <th>Report interval duration</th>
      <th># RIDs</th>
      <th>Actions</th>
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="Report ID" class="input-sm form-control" type="search" [(ngModel)]="reportIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Report Request ID" class="input-sm form-control" type="search" [(ngModel)]="reportRequestIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="VEN ID" class="input-sm form-control" type="search" [(ngModel)]="venIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Metadata Report ID" class="input-sm form-control" type="search" [(ngModel)]="metadataReportSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Granularity" class="input-sm form-control" type="search" [(ngModel)]="granularitySearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Report Back Duration" class="input-sm form-control" type="search" [(ngModel)]="reportBackDurationSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Report Interval Start" class="input-sm form-control" type="search" [(ngModel)]="reportIntervalStartSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Report Interval Duration" class="input-sm form-control" type="search" [(ngModel)]="reportIntervalDurationSearch" (input)="triggerSearch()"/></th>
      <th></th>
      <th></th> <!-- Actions column -->
    </tr>
    </thead>
    <tbody>
      @for(registeredReport of displayedRegisteredReports | paginate: paginationModel; track registeredReport) {
        <tr>
          <td>{{registeredReport.id}}</td>
          <td>{{registeredReport.report_request_id}}</td>
          <td>{{registeredReport.ven?.ven_id}}</td>
          <td>{{registeredReport.metadata_report?.report_specifier_id}} : {{registeredReport?.metadata_report?.label}}</td>
          <td>{{registeredReport.granularity}}</td>
          <td>{{registeredReport.report_back_duration}}</td>
          <td>{{registeredReport.report_interval_dtstart}}</td>
          <td>{{registeredReport.report_interval_duration}}</td>
          <td>{{registeredReport.rids.length || 0}}</td>
          <td>
            <div class="btn-group">
              <a
                class="btn btn-default"
                (click)="nextPage(registeredReport.id, '/reportHistory', router)"
                name="reportHistory"
              >View History</a>
              @if(isAdmin) {
                <a
                  class="btn btn-default"
                  (click)="nextPage(registeredReport.id, '/editRegisteredReport', router)"
                  name="editRegisteredReport"
                >Edit</a>
                <button
                  class="btn btn-danger"
                  type="button"
                  (click)="delete(registeredReport)"
                >
                  Cancel
                </button>
              }
            </div>
          </td>
        </tr>
      }
      @if(displayedRegisteredReports.length <= 0) {
        <tr>
          <td colspan="10" style="text-align: center;">No registered reports found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" colspan="10">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
